var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "pdf-container",
    },
    [
      _c(
        "div",
        { staticClass: "page-tool" },
        [
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.pageNum <= 1 },
                  on: { click: _vm.prevPage },
                },
                [_vm._v("上一页")]
              ),
              _c("span", [
                _vm._v(_vm._s(_vm.pageNum) + " / " + _vm._s(_vm.totalPage)),
              ]),
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.pageNum >= _vm.totalPage },
                  on: { click: _vm.nextPage },
                },
                [_vm._v("下一页")]
              ),
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "danger" },
              on: { click: _vm.handleAudit },
            },
            [_vm._v(_vm._s(_vm.auditText))]
          ),
        ],
        1
      ),
      _c("div", { ref: "scrollBox", staticClass: "pdf-scroll-box" }, [
        _c("canvas", { ref: "pdfCanvas" }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }